module.exports = __webpack_public_path__ + "static/media/item_2_10.7e5e9be4.png";